export default __webpack_public_path__ + "30bbde006d9a72c30fce702b98fa32ce.svg";